const isApp = document.documentElement.attributes["data-rendering-target"] == "apps"

// These are 'back doors' added on the client, only use for device specific logic
const isAndroid = document.documentElement.attributes["data-app-os"] == "android"
const isIOS = document.documentElement.attributes["data-app-os"] == "ios"

export { isApp, isAndroid, isIOS }